<template>
    <div class="main-nav-shell">
        <MobileNav :brand-items="visibleBrandItems" />
        <DesktopNav />
        <Search v-if="useProducts" />
    </div>
</template>

<script setup>
import { computed, getCurrentInstance } from "vue";
import Search from "../filters/Search.vue";
import DesktopNav from "./DesktopNav.vue";
import MobileNav from "./MobileNav.vue";
import { brandItems, visibleMenuItems } from "./menuLinks";

const { proxy } = getCurrentInstance();
const useProducts = computed(() => proxy.$store.state.useProducts);
const visibleBrandItems = computed(() => visibleMenuItems(brandItems));
</script>
